import React from 'react';

const COLORS = [
  ['#DBEAFE','#1D4ED8'], ['#D1FAE5','#065F46'], ['#FEE2E2','#991B1B'],
  ['#EDE9FE','#5B21B6'], ['#FEF3C7','#92400E'], ['#FCE7F3','#9D174D'],
];

function hashName(name = '') {
  let h = 0;
  for (let c of name) h = (h * 31 + c.charCodeAt(0)) & 0xffff;
  return h % COLORS.length;
}

export default function Avatar({ firstName = '', lastName = '', size = 38 }) {
  const initials = `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase() || '?';
  const [bg, fg] = COLORS[hashName(firstName + lastName)];
  return (
    <div style={{
      width: size, height: size, borderRadius: size * 0.28,
      background: bg, color: fg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.36, fontWeight: 700, flexShrink: 0,
      fontFamily: 'inherit', letterSpacing: '-0.5px',
    }}>
      {initials}
    </div>
  );
}
